import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2, AlertTriangle } from "lucide-react";

interface DeleteSectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sectionLabel: string;
  onConfirm: () => void;
}

export function DeleteSectionDialog({
  open,
  onOpenChange,
  sectionLabel,
  onConfirm,
}: DeleteSectionDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Remove "${sectionLabel}" Section?`}
      description="Are you sure you want to remove this section from your academic profile?"
    >
      <div className="space-y-4 pt-2">
        <div className="flex items-start gap-3 p-3.5 rounded-lg bg-destructive/10 border border-destructive/20 text-xs text-foreground">
          <AlertTriangle className="h-4 w-4 text-destructive shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="font-semibold text-destructive">This action will remove the section from your layout.</p>
            <p className="text-muted-foreground">
              You can re-add the section at any time using the "Add Section" menu.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onOpenChange(false)}
            className="text-xs h-8"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="text-xs h-8 gap-1.5 font-medium"
          >
            <Trash2 className="h-3.5 w-3.5" />
            Remove Section
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
